import { createRoot } from "react-dom/client";
import { PriceComparison } from "../price_comparison/PriceComparison";

export const initPriceComparison = (isChild = false) => {
  const comparisonContainer = document.getElementById("price_comparison");

  if (comparisonContainer) {
    const { caseId, payorShowPriceComparison } = comparisonContainer.dataset;
    const showPriceComparison = payorShowPriceComparison === "true";

    const root = createRoot(comparisonContainer);
    if (isChild) {
      root.render(<PriceComparison caseId={caseId} payorShowPriceComparison={showPriceComparison} />);
    } else {
      root.render(<PriceComparison caseId={caseId} />);
    }
  }
};
